import React, {FC, PropsWithChildren, useEffect, useRef} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../libs/shared/helpers/src/react/reactHelpers';

/*
 * Props.
 */

interface StringifierProps {
  onTextChange: HandlerOf<string>;
}

/*
 * Style.
 */

const StyledInvisibleDiv = styled.div`
  height: 1px;
  width: 1px;
  position: absolute;
  left: -100000px;
  opacity: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
`;

/*
 * Component.
 */

export const Stringifier: FC<PropsWithChildren<StringifierProps>> = (props) => {
  // 1. Create a ref to attach on our div.
  const divRef = useRef<HTMLDivElement>(null);

  // 2. Setup an effect to run after rendering.
  useEffect(() => {
    // 2a. Grab the actual DIV node.
    const currentDiv = divRef.current;
    // 2b. Call `onTextChange` with the innerText of that div element.
    props.onTextChange((currentDiv && currentDiv.innerText) || '');
  });

  // 3. Render inside an invisible element.
  return (
    <StyledInvisibleDiv ref={divRef} aria-hidden>
      {props.children}
    </StyledInvisibleDiv>
  );
};
